import {
  Accordion,
  AccordionButton,
  Text,
  AccordionIcon,
  AccordionPanel,
  Box,
  AccordionItem,
  Center,
} from "@chakra-ui/react";
import React from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Helmet } from "react-helmet-async";
import api from "../../utils/ApiMethod";

const EventOrg2 = () => {
  // fetch data from api
  const [events, setEvents] = React.useState([]);
  React.useEffect(() => {
    const handleFetchData = async () => {
      try {
        // fetch from /data/events-log.json
        const data = await api.fetchData("/contents/events-log-en");
        //   filter those whose eventDate exceeds today
        // sort by item.eventDate
        setEvents(
          data
            .filter((item) => new Date(item.eventDate) < new Date())
            .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate)),
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    handleFetchData();
  }, []);
  return (
    <div
    // style={{ backgroundImage: 'linear-gradient(to bottom, #0a3272, white)' }}
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Event Organization - Bihar State Sports Authority</title>
        <meta
          name="description"
          content="Learn about BSSA's initiatives in organizing state-level sports events and competitions to promote athletic talent in Bihar."
        />
      </Helmet>

      <Center p={6} m={6} flexDirection="column" w="100%">
        {/* Header – outside Accordion, full width */}
        <Box boxShadow="lg" p="1" rounded="md" bg="#c0c9d0" mb={4} w="100%">
          <Text
            fontWeight="bold"
            textTransform="uppercase"
            fontSize={["18", "24"]}
            letterSpacing="wide"
            color="#fcffff"
            py={2}
            backgroundColor="#0b2651"
            textAlign="center"
            borderRadius="15px"
          >
            Organized Program
          </Text>
        </Box>

        {/* Accordion – only items */}
        <Accordion defaultIndex={[0]} allowToggle w="100%">
          <Box
            bg="#0b244d"
            px={3} /* padding instead of margin */
            borderBottomLeftRadius={25}
            borderBottomRightRadius={25}
            w="100%"
          >
            {(events || []).map((item, index) => (
              <AccordionItem key={index}>
                <h1>
                  <AccordionButton>
                    <Box
                      as="span"
                      flex="1"
                      textAlign="left"
                      fontSize={["16", "18"]}
                      color="#f6ffff"
                      p="3"
                    >
                      {item?.eventName || ""}
                    </Box>
                    <AccordionIcon color="#f6ffff" fontSize={25} />
                  </AccordionButton>
                </h1>
                <AccordionPanel
                  pb={4}
                  textAlign="left"
                  fontSize={["13", "18"]}
                  color="#f6ffff"
                >
                  <div
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{
                      __html: item?.eventDescription || "",
                    }}
                  />
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Box>
        </Accordion>
      </Center>
    </div>
  );
};

export default EventOrg2;
